export const SBER_PRIME_SLUG = 'sber_prime';
